// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountTemplate } from './account-template';
import { Lookup } from './lookup';
import { SubEntry } from './sub-entry';
import { TaxGroup } from './tax-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TaxCode extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  taxCodeId!: number;
  accountUid?: string;
  createdBy!: string;
  createdDate!: Date;
  description?: string;
  locationId!: number;
  lookupId?: number;
  taxCode1!: string;
  taxGroupId?: number;
  taxRate!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountTemplates!: AccountTemplate[];
  accounts!: Account[];
  lookup!: Lookup;
  subEntries!: SubEntry[];
  taxGroup!: TaxGroup;
}

